import { render, staticRenderFns } from "./UseYnSelect.vue?vue&type=template&id=1f389164&"
import script from "./UseYnSelect.vue?vue&type=script&lang=js&"
export * from "./UseYnSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports